import { render, staticRenderFns } from "./SuggestedCreators.vue?vue&type=template&id=985883ae&scoped=true&"
import script from "./SuggestedCreators.vue?vue&type=script&lang=ts&"
export * from "./SuggestedCreators.vue?vue&type=script&lang=ts&"
import style0 from "./SuggestedCreators.vue?vue&type=style&index=0&id=985883ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985883ae",
  null
  
)

export default component.exports